import { useMemo } from 'react';
import { PageTabsNames } from '../../../constants/PageTabsNames';
import { biLogger } from '../../../services/biLogger';

export const useTrackTabClick = () =>
  useMemo(
    () => ({
      trackTabClick: ({ target }: { target: PageTabsNames }) =>
        biLogger.videoMakerVideoHomeTabClick({
          target,
        }),
    }),
    [],
  );
